import { render, staticRenderFns } from "./Trendyol.vue?vue&type=template&id=fb508b08&scoped=true"
import script from "./Trendyol.vue?vue&type=script&lang=js"
export * from "./Trendyol.vue?vue&type=script&lang=js"
import style0 from "./Trendyol.vue?vue&type=style&index=0&id=fb508b08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb508b08",
  null
  
)

export default component.exports